// src/composables/useConsultantService.js
import { modicareKycAxiosInstance } from '@/plugins/modicare-kyc-axios';
import { axiosInstance } from '@/plugins/axios';
import {ref} from 'vue';
export function useConsultantService() {
  const consultantServiceLoading = ref(true);
  const consultantServiceError = ref(true);
  const sendUserCreationMail = async (to,name,pc_id,mca_no)=>{
    try {
      let body =`Dear ${name},<br/>Thank you for joining Modiway as a Preferred Customer . Your PC ID is : ${pc_id}.<br/>
                As a Preferred Customer, you have access to special product promotions and discounts. To get these discounts be sure to shop at https://www.modiway.com and log in with your ID number.
                <br/>Sponsor MA-${mca_no}<br/>Name-${name}<br/><br/>You may also connect with our Contact Center on 0124-6912900.<br/>Thanks<br/>Modiway Support`;
      let subject='User Created Successfully';
      let is_html = true;
      const response = await axiosInstance.post('/send_mail', {
        to: to,
        subject: subject,
        body: body,
        is_html: is_html
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }

  };
  const consultantExistsAadhar = async (kyc_no) => {
    try {
      const response = await axiosInstance.get(`/users/check-kyc?kyc_no=${kyc_no}`);
      return response.data;
    } catch (err) {
      consultantServiceError.value = err;
      throw err;
    }finally {
      consultantServiceLoading.value = false;
    }
  };
  const consultantExistsPan = async (pan) => {
    try {
      const response = await modicareKycAxiosInstance.post('/consultant/exists/pan',
        { pan_no : pan });
      return response.data;
    } catch (err) {
      consultantServiceError.value = err;
      throw err;
    }finally {
      consultantServiceLoading.value = false;
    }
  };

  const consultantExistsEmail = async (email) => {
    try {
      const response = await modicareKycAxiosInstance.post('/consultant/exists/email',
        { email_id : email });
      return response.data;
    } catch (err) {
      consultantServiceError.value = err;
      throw err;
    }finally {
      consultantServiceLoading.value = false;
    }
  };

  const consultantExistsMobile = async (mobile) => {
    try {
      const response = await modicareKycAxiosInstance.post('/consultant/exists/mobile',
        { mobile_no : mobile });
      console.log(response);
      return response.data;
    } catch (err) {
      consultantServiceError.value = err;
      throw err;
    }finally {
      consultantServiceLoading.value = false;
    }
  };

  const findPlacement = async (sponsorNo,placementNo) => {
    try {
      const response = await modicareKycAxiosInstance.post('/consultant/find/placement',
        { sponsor_id:sponsorNo,placement_id : placementNo });
      return response.data;
    } catch (err) {
      consultantServiceError.value = err;
      throw err;
    }finally {
      consultantServiceLoading.value = false;
    }
  };

  const findSponsor = async (sponsorNo) => {
    try {
      const response = await modicareKycAxiosInstance.post('/consultant/find/sponsor'
        ,{ mca_no: sponsorNo });
      return response.data;
    } catch (err) {
      consultantServiceError.value = err;
      throw err;
    }finally {
      consultantServiceLoading.value = false;
    }
  };

  const sponsorConsultant = async (data) => {
    try {
      const response = await modicareKycAxiosInstance.post('/consultant/sponsor', data);
      return response.data;
    } catch (err) {
      consultantServiceError.value = err;
      throw err;
    }finally {
      consultantServiceLoading.value = false;
    }
  };

  const nameMatch = async (name1,name2) => {
    try {
      const response = await modicareKycAxiosInstance.post('/consultant/name/check', {consultant_name:name1,kyc_name:name2});
      return response.data;
    } catch (err) {
      consultantServiceError.value = err;
      throw err;
    }finally {
      consultantServiceLoading.value = false;
    }
  };
  const searchBy = async (pincode) => {
    try {
      const response = await modicareKycAxiosInstance.post('/consultant/searchby', {pincode:pincode}
        );
      return response.data;
    } catch (err) {
      consultantServiceError.value = err;
      throw err;
    }finally {
      consultantServiceLoading.value = false;
    }
  };

  return {
    consultantExistsAadhar,
    consultantExistsPan,
    consultantExistsEmail,
    consultantExistsMobile,
    findPlacement,
    findSponsor,
    sponsorConsultant,
    nameMatch,
    searchBy,
    sendUserCreationMail,
    consultantServiceError,
    consultantServiceLoading
  };
}
